export const isNullOrUndefinedOrEmpty = (value: unknown) =>
  value === null || value === '' || typeof value === 'undefined';
